module.exports = __webpack_public_path__ + "static/media/tdk.47a024e2.png";